import styled from 'styled-components'

export const TabComponent = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: hidden;
`

interface TabListProps {
  label: string
}

export const TabList = styled.div.attrs((props: TabListProps) => ({
  role: 'tablist',
  'aria-label': props.label
}))<TabListProps>`
  position: relative;
  width: 100%;

  display: flex;
  border-bottom: 1px solid ${props => props.theme.colors.colorDCE3ED};
`

interface TabItemProps {
  isSelected: boolean
  tabItemId: string
}

export const TabItem = styled.button.attrs((props: TabItemProps) => ({
  id: props.tabItemId,
  role: 'tab',
  type: 'button',
  'aria-selected': props.isSelected,
  'aria-controls': `${props.tabItemId}-panel`
}))<TabItemProps>`
  position: relative;
  padding: 0.75rem 0.5rem;

  font-family: 'Inter';
  font-style: normal;
  line-height: 15px;
  font-size: 15px;

  &[aria-selected='true'] {
    font-weight: 500;
    color: ${props => props.theme.colors.color122d52};
  }

  &[aria-selected='false'] {
    font-weight: 400;
    color: ${props => props.theme.colors.color545e6c};
  }

  background: transparent;
  border: none;
  cursor: pointer;
  transition: background 200ms ease-in-out;

  &:hover[aria-selected='false'] {
    &&::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: ${props => props.theme.colors.color545e6c59};
      border-radius: 50%;
    }
  }

  &:active[aria-selected='false'],
  &:focus-visible[aria-selected='false'] {
    color: ${props => props.theme.colors.color005597};
    &&::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: ${props => props.theme.colors.color005597};
    }
  }
`

export const TabIndicator = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 1px;
  background: ${props => props.theme.colors.color122d52};

  transition: all 300ms ease-in-out;
  transition-delay: 100ms;
`

interface TabPanelsProps {
  // isSelected: boolean
  tabItemId: string
}

export const TabPanel = styled.section.attrs((props: TabPanelsProps) => ({
  id: `${props.tabItemId}-panel`,
  role: 'tabpanel',
  'aria-labelledby': props.tabItemId
}))<TabPanelsProps>`
  position: relative;
  width: 100%;
  height: 100%;
  flex: 1;
`
